export default (token) => ({
    token,

    onInput({ target }){
        if (target.value.length > 6) {
            return;
        }

        this.token = String(target.value).replace(/\D/g, '');

        if (this.token.length === 6) {
            this.$wire.call('login');
            this.$refs.token.value = '';
        }
    },
});
